import { useEffect, useState } from "react";
import ProductsService from "../api/services/products.service";
import { InstallmentBankTypes } from "../api/types/products.types";

/**
 * The banks a shopper can pay in instalments with, as configured in the admin
 * panel. Public, so it works for signed-out visitors on a product page.
 *
 * Banks without a plan never reach the response, so anything returned here has
 * something to offer.
 */
export const useInstallmentBanks = () => {
  const [banks, setBanks] = useState<InstallmentBankTypes[]>([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await ProductsService.getInstallmentBanks();
        if (!cancelled) setBanks(res.data?.data ?? []);
      } catch (error) {
        // Instalments are additive information; failing to load them must not
        // take the surrounding page down.
        console.error("Could not load installment banks:", error);
        if (!cancelled) setBanks([]);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return banks;
};
